import React from 'react';
//nead reference for seleting(archiving) the audio
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faPlay,
    faAngleLeft,
    faAngleRight,
    faPause,
 } from "@fortawesome/free-solid-svg-icons";


const Player = ({ audioRef, currentSong, isPlaying, setIsPlaying, setSongInfo, songInfo, songs, setCurrentSong, setSongs }) => {
    
    const activeLibraryHandler = (nextPrev) => {
        const newSongs = songs.map((song) =>{
            if(song.id === nextPrev.id){
                return{
                   ...song,
                   active: true, 
                };
            }else{
                return{
                    ...song,
                    active: false,
                };
            }
        });
        setSongs(newSongs);  
        console.log("nextPrev")
    }

    //Event Handlers
    const playSongHandler = () =>{
        if(isPlaying){
            audioRef.current.pause();
            setIsPlaying(!isPlaying);
        }else{
            audioRef.current.play();
            setIsPlaying(!isPlaying);
        }
    };
    
    const getTime = (time) => {
        return (
            Math.floor(time / 60) + ":" + ("0" + Math.floor(time % 60)).slice(-2)
        );
    };     //Number nicely for you, seccond and minuitu
    //inputスライダーを操作できるようにする
    const dragHandler = (e) => {
        audioRef.current.currentTime = e.target.value;
        setSongInfo({ ...songInfo, currentTime: e.target.value});
    };
    const skipTrackHandler = async (direction) => {
        let currentIndex = songs.findIndex((song) => song.id === currentSong.id);
        if(direction === "skip-forward"){
            await setCurrentSong(songs[(currentIndex + 1) % songs.length]);
                //when the currentIndex +1 match to the sons.length, the number back to 0
                // put async and await for this action to finidh ,  wait a bit: await
            activeLibraryHandler(songs[(currentIndex + 1) % songs.length]);
        }
        if(direction === "skip-back"){
            if((currentIndex -1) % songs.length === -1){
            await setCurrentSong(songs[songs.length -1]);
            activeLibraryHandler(songs[songs.length -1]);
                //songs.length -1で　ex.lengthは8あるが実際には0から始まり7までの場合に対応させる
                if(isPlaying) audioRef.current.play();
                return;
                //when you return, everything skiping over after return
            }
            await setCurrentSong(songs[(currentIndex - 1) % songs.length]);
            activeLibraryHandler(songs[(currentIndex - 1) % songs.length]);
        }
        if(isPlaying) audioRef.current.play();
        //when they finish we can easy to play other song
    };
    //Add the styles
    const trackAnim = {
        transform: `translateX(${songInfo.animationPercentage}%)`
        //css rule `~~~~~(${~~~~~~}%)`
    }

    return(
        <div className="player">
            <div className="time-control">
                <p>{getTime(songInfo.currentTime)}</p>
            <div style={{background: `linear-gradient(to right, ${currentSong.color[0]},${currentSong.color[1]})`,}} className="track">   
                <input min={0}
                       max={songInfo.duration || 0} 
                       //NaNを見せないように　||0にするが実際は見える→getTimeで解決
                       //もしsongInfoのdurationがgetTimeできていなかった時には"0:00"をdisplayさせる
                       value={songInfo.currentTime}
                       onChange={dragHandler} //スライダーをマウスクリックで変更可能にさせる
                       type="range" />
                <div style={trackAnim} className="animate-track"></div>
            </div> 
                <p>{songInfo.duration ? getTime(songInfo.duration) : "0:00"}</p>
            </div>
            <div className="play-control">
                <FontAwesomeIcon 
                onClick={() => skipTrackHandler ("skip-back")} 
                className="skip-back" size="2x" icon={faAngleLeft}
                />
                <FontAwesomeIcon 
                onClick={playSongHandler} 
                className="play" 
                size="2x" 
                icon={isPlaying ? faPause : faPlay}
                />
                <FontAwesomeIcon 
                className="skip-forward" 
                size="2x" 
                icon={faAngleRight}
                onClick={() => skipTrackHandler ("skip-forward")} 
                /> 
            </div>
                
        </div>
    );
    // isPlaying ? faPause : faPlay what ever playing, shows faPause icon, not shows faPause
    // if~~ elseのshort hand
    //onTimeUpdate: special event like onClick, run every time change on the "audio"
    //onLoadedMetadate: after the loaded, the data updated and show me 
};

export default Player;